export const reportByList = [
  { label: 'Underwriting Year', value: 'UY' },
  { label: 'Treaty Year', value: 'TY' }
]

export const driList = [
  { label: 'Both', value: 'B' },
  { label: 'Direct', value: 'D' },
  { label: 'Reinsurance Inwards', value: 'R' }
]

export const riTypeList = [
  { label: 'C - Coinsurance', value: 'C' },
  { label: 'D - Statutory', value: 'D' },
  { label: 'F - Facultative', value: 'F' },
  { label: 'T - Treaty', value: 'T' },
  { label: 'W - Quota Share', value: 'W' }
]
